import { IOption } from '../../../models/IOption';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IConfigOptions } from '../../../models/IConfigOptions';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'ff-autocomplete-checkbox',
  templateUrl: './autocomplete-checkbox.component.html',
  styleUrls: ['./autocomplete-checkbox.component.scss']
})
export class AutocompleteCheckboxComponent {

  /**
   * Options to display as options in the dropdown
   * Use the IOption interface: { value: string; text: string; selected?: boolean; }
   * * @internal
  */
  @Input() options: IOption[] 

    /**
   * Options to display as options in the dropdown
   * Use the IConfigOptions interface: { disabled: boolean; }
   * * @internal
  */
  @Input() config?: IConfigOptions 

  /**
   * Return the selection updated each time the user check an option.
   * * @internal
  */
   @Output() selection = new EventEmitter<IOption[]> ();

  //boolean variable to control disabled property of the component
  isDisabled : boolean = false;


   constructor() { }

   ngOnInit() {
    this.isDisabled = this.config != undefined ? this.config.disabled : false;
}


   onChange = (option: IOption) => {
    option = {...option, selected: !option.selected};
    this.options = this.options.map(element => element.value === option.value
      ? {...element, selected: option.selected}
      : element);

      this.updateSelection();
  }

     /**
   * Return the updated array to the parent component
  */
  private updateSelection = (): void => {
    this.selection.emit(this.options);
  }


}
